<template>
    <!-- "Move to another column?" on the meeting board: after sending an item to a task manager (defaults to the next
         column) and after checking one off (defaults to the last); on a deck after checking a card off (CompanyBoard.vue).
         Move does the same as dropping the card there. -->
    <div class="error-msg-wrap">
        <div class="error-msg item-move-prompt">
            <h3>Move to Another Column?</h3>
            <p>{{ message }} Would you like to move this {{ noun || 'item' }} to a different column on the {{ board || 'meeting board' }}?</p>
            <select v-model="column" aria-label="Column">
                <option v-for="c in columns" :key="c" :value="c">{{ c }}{{ c == current ? ' (current)' : '' }}</option>
            </select>
            <div class="item-move-btns">
                <button type="button" class="btn-light" @click="$emit('cancel')">Not Now</button>
                <button type="button" class="btn" @click="move()">Move</button>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

// columns: the board's column names. current: the item's column. defaultColumn: where the picker starts.
// noun / board: the wording ('item' / 'meeting board' by default). Emits move(column) only when it's a different column, otherwise cancel.
export default defineComponent({
    name: 'MoveColumnPrompt',
    props: [ 'message', 'columns', 'current', 'defaultColumn', 'noun', 'board' ],
    emits: [ 'move', 'cancel' ],
    data() {
        return {
            column: this.defaultColumn || ''
        }
    },
    methods: {
        move() {
            if(this.column && this.column != this.current) {
                this.$emit('move', this.column);
            } else {
                this.$emit('cancel');
            }
        }
    }
});
</script>
